import { render } from "./MStarsResult.vue?vue&type=template&id=7698c383"
import script from "./MStarsResult.vue?vue&type=script&lang=js"
export * from "./MStarsResult.vue?vue&type=script&lang=js"

import "./MStarsResult.vue?vue&type=style&index=0&id=7698c383&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__